export default __webpack_public_path__ + "static/media/aqi_1.4a5c56d6.svg";